export default __webpack_public_path__ + "static/media/fund.fde0f97b.png";